import React from 'react';
import { motion } from 'framer-motion';
import { testimonialsFull } from '../data/salesData';
import { StarIcon } from 'lucide-react';
export function TestimonialsFull() {
  return <section className="py-16 px-4 bg-surface-light" data-id="element-172" data-mp="m83ri1wu6aer">
      <div className="max-w-6xl mx-auto" data-id="element-173" data-mp="m8di9rppglli">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-174" data-mp="r6osw4ntr04s">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-primary" data-id="element-175" data-mp="3ulb4qtbb7sje">
            Lo que dicen los instructores
          </h2>
          <div className="flex items-center justify-center gap-2 text-2xl" data-id="element-176" data-mp="88chsddcrg6k">
            <span className="font-bold text-gray-900" data-id="element-177" data-mp="36yco9vn6wklh">4.9/5</span>
            <div className="flex" data-id="element-178" data-mp="36xt74h5d608i">
              {[1, 2, 3, 4, 5].map(i => <StarIcon key={i} className="w-6 h-6 fill-highlight text-highlight" data-id="element-179" data-mp="3bvl8e1rweypd" />)}
            </div>
          </div>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-180" data-mp="24eu4fs0rek30">
          {testimonialsFull.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index % 2 * 0.1
        }} className="bg-white rounded-lg p-6 shadow-sm border border-gray-200" data-id="element-181" data-mp="1zlhkhv70z1gl" data-mpi={index}>
              <div className="flex gap-0.5 mb-4" data-id="element-182" data-mp="3b2r4qjxz9xiy">
                {[1, 2, 3, 4, 5].map(i => <StarIcon key={i} className="w-5 h-5 fill-highlight text-highlight" data-id="element-183" data-mp="363o55f0rojid" />)}
              </div>
              <div className="flex items-start gap-4 mb-4" data-id="element-184" data-mp="3p6ga25zgsqci">
                <div className="w-12 h-12 rounded-full bg-primary text-white flex items-center justify-center font-bold flex-shrink-0" data-id="element-185" data-mp="3tzswc9go8l23">
                  {testimonial.initials}
                </div>
                <div data-id="element-186" data-mp="3l7ha6zslbjrx">
                  <p className="font-semibold text-gray-900" data-id="element-187" data-mp="3l6xsnk6uqxef">
                    {testimonial.name}
                  </p>
                </div>
              </div>
              <p className="text-gray-700 italic" data-id="element-188" data-mp="grg28xnnkeg8">"{testimonial.quote}"</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}